import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import React from "react";

const useStyle = makeStyles((theme) => ({
    root: {
        margin: "40px 0px",
    },
    title: {
        fontSize: "1.5rem !important",
        fontWeight: "500 !important",
        marginBottom: "20px !important",
        textAlign: "center",
    },
}));

const TransferMoney = () => {
    const classes = useStyle();
    return (
        <div className={classes.root}>
            <Typography className={classes.title}>
                Terms & Conditions for <br />
                “ST PAY to Visa Debit Fund Transfer Money”
            </Typography>

            <ol >
                <li>Customers must carefully enter the correct Debit Card number while initiating a fund transfer from their ST Pay to Visa Debit Card (Money Transfer via Visa Debit Card). ST Pay shall not be responsible for any failure, misdirection or loss of funds resulting from incorrect or incomplete card details provided by the customer.</li>

                <li>To authorize the transaction, customers are required to enter their ST Pay authentication credentials (such as PIN, OTP or biometric verification, as applicable). Customers are solely responsible for maintaining the confidentiality of such credentials and must not disclose them to any third party.</li>

                <li>Once a ST Pay to Visa Debit Card transaction is successfully initiated, it cannot be cancelled or reversed by ST Pay. Customers are therefore advised to verify all transaction details carefully before confirming the transfer.</li>

                <li>ST Pay does not guarantee immediate credit of funds. Any delay in crediting funds arising from the processing time of the destination bank, card network, or other intermediary institutions shall not be the responsibility of ST Pay.</li>

                <li>ST Pay shall not be liable for any transaction that is declined, reversed, or blocked due to customer error, non-compliance with applicable rules, insufficient balance, incorrect information, or restrictions imposed by the issuing bank, card network, or regulatory authority.</li>

                <li>A ST PAY customer shall be charged 1.5% on the transfer amount as applicable.</li>
                <li>For transfers made to Visa Debit Cards, the credited amount may be reflected within a short time after successful transaction confirmation. In some cases, crediting of funds may take up to seven working days, subject to the processing timelines of the respective bank and card network.</li>

                <li>In case of pending transactions, failed transfers, or service-related queries, customers are requested to contact ST Pay Customer Support through the official helpline <a href="tel:+8809617343434" style={{ color: "#3d96ff" }}>+8809617343434</a>, or email <a href="mailto:support@stpay.net" style={{ color: "#3d96ff" }}>support@stpay.net</a>, as communicated by ST Pay from time to time.</li>

                <li>ST Pay reserves the right to modify, suspend, or discontinue the ST Pay to Visa Debit Card service or amend these Terms & Conditions, at any time in accordance with applicable laws and regulatory requirements, without prior notice to customers.</li>
                <br />
            </ol>


            <style>{`
                ol {
                    margin-left: -10px;
                    text-align: justify;
                }

                ol li::marker {
                    font-weight: 600;
                }

                ol li {
                    padding-left: 15px;
                    margin-bottom: 10px;
                }
            `}</style>

        </div>
    );
};

export default TransferMoney;